import React from "react";
import ResultForm from "../../components/ResultForm";

const ResultPage = () => {
  return <ResultForm />;
};

export default ResultPage;
